import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class DistributionPayableListItem extends SearchModelBase {
    id: number = 0;
    status: string = '';

    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;

    distTo: string = '';
    description: string = '';

    amount: number|null = null;
    fromAmount: number|null = null;
    toAmount: number|null = null;

    paid: string = '';
    Remark: string | null = null;

    
    paidAmount: number|null = null;
    fromPaidAmount: number|null = null;
    toPaidAmount: number|null = null;

    balance: number|null = null;
    fromBalance: number|null = null;
    toBalance: number|null = null;

    u1ID: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;

    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    
    
    

    private static ExportCollection: XCol.XExportColumn[] = [

        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'Distribution To', width: 150, dataIndex: 'distTo'}),
        XCol.Create({ col: 3, text: 'Description', width: 150, dataIndex: 'description'}),
        XCol.Create({ col: 4, text: 'Amount', width: 100, dataIndex: 'amount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 5, text: 'Paid', width: 40, dataIndex: 'paid',  align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'Remark', width: 150, dataIndex: 'remark'}),
        XCol.Create({ col: 7, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 9, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];


    // public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
    //     let returnCloumns = _.cloneDeep(this.ExportCollection);
    //     if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
    //     return returnCloumns;
    // };

    public static getExportCollection(): XCol.XExportColumn[] {
         return this.ExportCollection;
     };   
	
    public static OrderBy = { orderBy: DistributionPayableListItem.prototype.id, orderByAscending: false };

    public static formatData(data: DistributionPayableListItem[]) {
        return data.map((d: DistributionPayableListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        amount: {from: 'fromAmount', to: 'toAmount'},
        paidAmount: {from: 'fromPaidAmount', to: 'toPaidAmount'},
        balance: {from: 'fromBalance', to: 'toBalance'},
    }
}
